import moment, { Moment } from 'moment';
import React, { FC, useCallback, useEffect, useState } from 'react';
import { IntegrationField } from 'api/integrations';
import { DatePicker } from 'components/atoms/date-picker';
import { humanise } from 'components/atoms/humanised-date';

type OnChangeParams = {
  integrationFieldId: string;
  valueStr: number | null;
};

interface IntegrationDateField {
  field: IntegrationField;
  onChange?: (data: OnChangeParams) => void;
  placeholder?: string;
  disabled?: boolean;
  fieldValue?: number;
}

export const IntegrationDateField: FC<IntegrationDateField> = ({
  field,
  onChange,
  placeholder = '',
  disabled = false,
  fieldValue,
}) => {
  // changed value prop to fieldValue as when sending it as value the prop was undefined in the child.
  const [currentValue, setCurrentValue] =
    useState<number | undefined>(fieldValue);

  useEffect(() => {
    setCurrentValue(fieldValue);
  }, [fieldValue]);

  const handleOnChange = useCallback(
    (date: Moment | null) => {
      if (onChange != null) {
        if (date != null) {
          const timestamp = date.endOf('day').valueOf();

          setCurrentValue(timestamp);
          onChange({
            integrationFieldId: field?.integrationFieldId,
            valueStr: timestamp,
          });
        } else {
          setCurrentValue(undefined);
          onChange({
            integrationFieldId: field?.integrationFieldId,
            valueStr: date,
          });
        }
      }
    },
    [setCurrentValue, field, onChange],
  );

  return (
    <DatePicker
      style={{ width: '100%' }}
      placeholder={placeholder}
      format={humanise}
      role="button"
      tabIndex={0}
      allowClear
      value={currentValue != null ? moment(currentValue) : undefined}
      onChange={handleOnChange}
      disabled={disabled}
    />
  );
};
